import { render, staticRenderFns } from "./UnderMantainance.vue?vue&type=template&id=aa55f7e0&scoped=true"
var script = {}
import style0 from "./UnderMantainance.vue?vue&type=style&index=0&id=aa55f7e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa55f7e0",
  null
  
)

export default component.exports